import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("HomepagePresentationSlide", {
  title: "Hompage Slide",
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [
    ...defaultPageProperties,
    "subtitle",
    "targetLink",
    "backgroundImage",
    "imageLeft",
    "imageBottom",
    "backgroundColorHeadline",
  ],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: ["sortKey"],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  validations: [...metadataValidations],
});
